import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Spinner } from 'react-bootstrap';
import { FaCheck, FaWindowClose } from 'react-icons/fa';
import { toast } from 'react-toastify';
import moment from 'moment';
import { listarContratosRescisao } from '~/Services/GestaoIPTUService';
import { extrairMensagemErro } from '~/Utils/Helpers';

// D2 — Sel Contrato (réplica fiel de uSelContrato.dfm + .pas).
// Lista os boletos com histórico de rescisão (Tipo='R' em Doc_Boleto) pro
// imóvel e devolve o escolhido via onConfirmar({codigoBoleto, codigoFamilia}).
// Acionado pelo menu "Imprimir Cálculo de Rescisão" quando o imóvel tem
// MovTemRescisao='S' (UImovelCarne.pas:ImprimeCalculoRescisao linhas 782-795).
const ModalSelContrato = ({ show, onHide, codigoAtivo, onConfirmar }) => {
  const [carregando, setCarregando] = useState(false);
  const [contratos, setContratos] = useState([]);
  const [selecionado, setSelecionado] = useState(null);

  useEffect(() => {
    if (!show || !codigoAtivo) {
      setContratos([]);
      setSelecionado(null);
      return undefined;
    }
    let ativo = true;
    setCarregando(true);
    listarContratosRescisao(codigoAtivo)
      .then((lista) => {
        if (!ativo) return;
        const arr = Array.isArray(lista) ? lista : [];
        setContratos(arr);
        setSelecionado(arr.length === 1 ? arr[0] : null);
      })
      .catch((err) => {
        if (!ativo) return;
        toast.error(extrairMensagemErro(err));
        setContratos([]);
      })
      .finally(() => {
        if (ativo) setCarregando(false);
      });
    return () => { ativo = false; };
  }, [show, codigoAtivo]);

  const handleOk = () => {
    if (!selecionado) {
      toast.warning('Selecione um contrato para continuar.');
      return;
    }
    onConfirmar({
      codigoBoleto: selecionado.codigo_boleto,
      codigoFamilia: selecionado.codigo_familia,
    });
  };

  const fmtData = (v) => (v ? moment(v).format('DD/MM/YYYY HH:mm:ss') : '—');

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 18 }}>Selecione o Contrato</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ overflowX: 'auto' }}>
          <Table bordered hover size="sm" style={{ fontSize: 12, marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={{ width: 40 }}>&nbsp;</th>
                <th style={{ color: '#001f5b' }}>Data</th>
                <th style={{ color: '#001f5b' }}>Descrição</th>
              </tr>
            </thead>
            <tbody>
              {carregando ? (
                <tr>
                  <td colSpan={3} className="text-center py-3">
                    <Spinner animation="border" variant="primary" size="sm" />
                  </td>
                </tr>
              ) : contratos.length === 0 ? (
                <tr>
                  <td colSpan={3} className="text-center text-muted py-3">
                    Nenhum contrato rescindido encontrado.
                  </td>
                </tr>
              ) : (
                contratos.map((c) => {
                  const marcado = selecionado && selecionado.codigo_boleto === c.codigo_boleto;
                  return (
                    <tr
                      key={c.codigo_boleto}
                      onClick={() => setSelecionado(c)}
                      onDoubleClick={() => {
                        setSelecionado(c);
                        onConfirmar({
                          codigoBoleto: c.codigo_boleto,
                          codigoFamilia: c.codigo_familia,
                        });
                      }}
                      style={{
                        cursor: 'pointer',
                        backgroundColor: marcado ? '#cfe2ff' : undefined,
                      }}
                    >
                      <td className="text-center">
                        <input
                          type="radio"
                          name="contrato"
                          checked={marcado || false}
                          onChange={() => setSelecionado(c)}
                        />
                      </td>
                      <td>{fmtData(c.data)}</td>
                      <td>{c.texto || '—'}</td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={handleOk}
          disabled={carregando || !selecionado}
          className="d-inline-flex align-items-center"
        >
          <FaCheck className="mr-2" /> OK
        </Button>
        <Button
          variant="light"
          onClick={onHide}
          disabled={carregando}
          className="d-inline-flex align-items-center"
        >
          <FaWindowClose />
          <span className="ml-2">Fechar</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalSelContrato;
